import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const user = sessionStorage.getItem("token");
  const location = useLocation();

  if (!user) {
    return (
      <Navigate to={"/customerGatway"} replace state={{ from: location }} />
    );
  }
  return children;
};

export default ProtectedRoute;
